import * as React from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import { fetchData, postQuery } from '../utils';
import * as AuthStore from "../store/Auth";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { Table, Select, Input, Button, Tabs, Row, Col, message, Popconfirm  } from 'antd';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons/lib';
import { busyGif } from '../img';
const { TabPane } = Tabs;
const { Option } = Select;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class DataManagement extends React.Component<AuthProps>
{
    public state =
        {
            clientSite: false,
            loading: false,
            siteId: 0,            
            states: [],
            sites: [],
            site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
            state: { stateId: 0, name: '', code: '', sites: [] }
        };
    ////@ts-ignore
    async componentDidMount()
    {
        let el = this;
        let user = el.props.appUser;
        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0)
            {
                let state: any = states[0];
                this.setState({ state });
            }
        }

        let statesLoaded = true;
        this.setState({ states, sites, statesLoaded });

    }

    selectSite(value: any)
    {
        if (value)
        {
            let siteId = value.key;
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === siteId });
            if (sites.length > 0)
            {
                this.setState({ site: sites[0] });
            }
            else
            {
                message.error('Facility Details could not be retrieved. Please refresh the page and try again');
            }
        }
    }

    selectState(value: any)
    {
        if (!value)
        {
            return;
        }
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                let state: any = states[0];
                this.setState({ state });
            }
        }

    }

    ////@ts-ignore
    async dropFacilityData()
    {
        let el = this;   
        var site = this.state.site;      
        if (site.id < 1)
        {
            message.error("Please select a Facility");
            return;
        }

        var query = `/api/Site/dropFacilityData?facilityId=` + site.id;

        el.setState({ loading: true });
        let sts = await postQuery(query);
        el.setState({ loading: false });
        if (sts > 0)
        {
            message.error('Facility Data was successfully droped');
        }
        else {
            message.error('An error was encountered and the facility Data could not be droped');
        }
    }
       
    render()
    {
        const { loading, site, state, states } = this.state;

        let el = this;
        if (!el.props.appUser.isAuthenticated || el.props.appUser.role !== "1") {
            return <Redirect to="/welcome" />;
        }

        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR - Manage Facility Data</title>
                </Helmet>
                {<img className="waiter2" src={busyGif} alt="" style={{ width: '54px', height: '54px', display: loading ? 'block' : 'none' }} />}
                <Row style={{ marginTop: '2px' }}>
                    <Col span={24} style={{ marginTop: '15px', marginBottom: '15px' }}>
                        <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Manage Facility Data</h4>
                    </Col>
                </Row>
                <div className="custom-filter-dropdown">
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}></h4>
                        </Col>
                    </Row>
                    <Row gutter={2} style={{ marginTop: '10px', paddingBottom: '10px' }} id="srchDv">
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <Select
                                labelInValue
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                //@ts-ignore
                                value={{ key: state.stateId }}
                                style={{ width: '100%' }}
                                placeholder="Select State"
                                onChange={(value) => this.selectState(value)}
                            >
                                <Option key={0} value={0}>-- Select State --</Option>
                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6} style={{ marginLeft: '5px'}}>
                            <Select
                                labelInValue
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                style={{ width: '100%' }}
                                //@ts-ignore
                                value={{ key: site.id > 0 ? site.id : '' }}
                                placeholder="Select Site"
                                onChange={(value) => this.selectSite(value)}
                            >
                                <Option key="" value="">-- Select Site --</Option>
                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                            </Select>
                        </Col>
                        <Col span={3}>
                            <Popconfirm onConfirm={() => this.dropFacilityData()} title="Are you sure you want to drop this Facility's Data？" icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                                <Button id="searchBtnP" disabled={loading} className="login-button" type="default" size="large"
                                    style={{ float: 'left', marginLeft: '10px' }} danger>
                                    <DeleteOutlined /> {loading ? 'Please wait...' : 'Drop Data'}
                                </Button>
                            </Popconfirm>                            
                        </Col>
                    </Row>
                </div>
                <br />                
            </div>
        )
    }
}
export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(DataManagement as any);
